module.exports = __webpack_public_path__ + "img/accounts.2d34820b.svg";